import macedonian_flag from '../../../assets/images/macedonian-flag-circle.png'
import english_flag from '../../../assets/images/uk-flag-circle.png'
import albanian_flag from '../../../assets/images/albanian-flag-circle.png'

export interface ILanguageItem {
    tag: "en" | "mk" | "al",
    label: string,
    flag: any
}

export const languageMenuItems: ILanguageItem[] = [
    {
        tag: "mk",
        label: "Македонски",
        flag: macedonian_flag
    },
    {
        tag: "al",
        label: "Shqip",
        flag: albanian_flag
    },
    {
        tag: "en",
        label: "English",
        flag: english_flag
    },
]
